var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-detail"},[_c('p',[_vm._v("Products")]),_vm._v("\n    "+_vm._s(_vm.Products)+"\n\n    "),_c('br'),_c('br'),_vm._v(" "),_c('p',[_vm._v("Total order")]),_vm._v("\n    "+_vm._s(_vm.totalOrder)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cd17d70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ExcelExport.vue
// module id = null
// module chunks = 